import { render, staticRenderFns } from "./document_company.vue?vue&type=template&id=653c9014"
import script from "./document_company.vue?vue&type=script&lang=js"
export * from "./document_company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports